var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { occupationEntityName } from '../../../../backend/config/shared';
import { getClassifierIdByNameAsync } from '../../../../ui/features/classifiers-admin-pages/utils/getClassifierIdByNameAsync';
import { getClassifierNameAsync } from '../../../../ui/features/classifiers-admin-pages/utils/getClassifierNameAsync';
import { useFeatureFlags } from '../../../../ui/hooks';
import { ClassifierAdminPage, ClassifierValue, SlideoutFields, } from '@juvare/platform-sdk-react/ui/features/classifiers';
import CheckIcon from '@mui/icons-material/Check';
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography, capitalize } from '@mui/material';
import React from 'react';
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(SlideoutFields, { fields: [
                {
                    label: 'Status',
                    value: capitalize(props.response.data.status),
                },
                {
                    label: 'Description',
                    value: props.response.data.description,
                },
                {
                    label: 'Discipline ID',
                    value: props.response.data.disciplineId,
                },
                {
                    label: 'Group',
                    value: React.createElement(ClassifierValue, { entity: 'occupationGroup', id: props.response.data.groupId }),
                },
                {
                    label: 'MRC Report Occupation',
                    value: React.createElement(ClassifierValue, { entity: 'occupationReport', id: props.response.data.reportId }),
                },
                {
                    label: 'O*NET-SOC Code',
                    value: props.response.data.oNetSocCode,
                },
                {
                    label: 'Emergency Support Function',
                    value: React.createElement(ClassifierValue, { entity: 'occupationFunction', id: props.response.data.functionId }),
                },
                ...(props.credentialEnabled
                    ? [
                        {
                            label: 'Calculate Emergency Credential Level',
                            value: props.response.data.calculateEcl ? 'Yes' : 'No',
                        },
                    ]
                    : []),
            ] }),
        props.credentialEnabled && (React.createElement(Box, { mt: 1 },
            React.createElement(Typography, { variant: 'body1', fontWeight: 500 }, "Occupation Credentials:"),
            props.response.data.credentials && props.response.data.credentials.length > 0 ? (React.createElement(Table, { size: 'small', sx: { mt: 1, mb: 2 } },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "Credential"),
                        React.createElement(TableCell, null, "Jas Board"),
                        React.createElement(TableCell, { sx: { width: 72 } }, "ECL 1"),
                        React.createElement(TableCell, { sx: { width: 72 } }, "ECL 2"),
                        React.createElement(TableCell, { sx: { width: 72 } }, "ECL 3"),
                        React.createElement(TableCell, { sx: { width: 72 } }, "ECL 4"))),
                React.createElement(TableBody, null, props.response.data.credentials.map((credential) => (React.createElement(TableRow, { key: credential.credentialId },
                    React.createElement(TableCell, null,
                        React.createElement(ClassifierValue, { entity: 'occupationCredential', id: credential.credentialId, variant: 'body2' })),
                    React.createElement(TableCell, null,
                        React.createElement(ClassifierValue, { entity: 'jasBoard', id: credential.jasBoardId, variant: 'body2' })),
                    React.createElement(TableCell, null, credential.ecl1 && React.createElement(CheckIcon, null)),
                    React.createElement(TableCell, null, credential.ecl2 && React.createElement(CheckIcon, null)),
                    React.createElement(TableCell, null, credential.ecl3 && React.createElement(CheckIcon, null)),
                    React.createElement(TableCell, null, credential.ecl4 && React.createElement(CheckIcon, null)))))))) : ('-')))));
};
const formConfig = (credentialEnabled) => ({
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Name',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
        {
            type: 'form.text',
            key: 'description',
            label: 'Description',
        },
        {
            type: 'form.text',
            key: 'disciplineId',
            label: 'Discipline ID',
        },
        {
            type: 'form.select',
            key: 'groupId',
            label: 'Group',
            valueProvider: {
                type: 'classifier.occupationGroup',
            },
        },
        {
            type: 'form.select',
            key: 'reportId',
            label: 'MRC Report Occupation',
            valueProvider: {
                type: 'classifier.occupationReport',
            },
        },
        {
            type: 'form.text',
            key: 'oNetSocCode',
            label: 'O*NET-SOC Code',
            mask: {
                type: 'pattern',
                pattern: '00-0000',
                placeholderChar: '_',
            },
        },
        {
            type: 'form.select',
            key: 'functionId',
            label: 'Emergency Support Function',
            valueProvider: {
                type: 'classifier.occupationFunction',
            },
        },
        {
            type: 'form.checkbox',
            key: 'calculateEcl',
            label: 'Calculate Emergency Credential Level',
            hidden: !credentialEnabled,
        },
        {
            type: 'form.dataGrid',
            key: 'credentials',
            label: 'Occupation Credentials',
            addControls: true,
            hidden: !credentialEnabled,
            children: [
                {
                    type: 'form.select',
                    key: 'credentialId',
                    label: 'Credential',
                    valueProvider: {
                        type: 'classifier.occupationCredential',
                    },
                    validate: {
                        required: true,
                    },
                    style: {
                        width: 500,
                    },
                },
                {
                    type: 'form.select',
                    key: 'jasBoardId',
                    label: 'Jas Board',
                    valueProvider: {
                        type: 'classifier.jasBoard',
                    },
                },
                {
                    type: 'form.checkbox',
                    key: 'ecl1',
                    label: 'ECL 1',
                    defaultValue: false,
                },
                {
                    type: 'form.checkbox',
                    key: 'ecl2',
                    label: 'ECL 2',
                    defaultValue: false,
                },
                {
                    type: 'form.checkbox',
                    key: 'ecl3',
                    label: 'ECL 3',
                    defaultValue: false,
                },
                {
                    type: 'form.checkbox',
                    key: 'ecl4',
                    label: 'ECL 4',
                    defaultValue: false,
                },
            ],
        },
    ],
});
const csvFileHeader = [
    'ID',
    'Name',
    'Status',
    'Description',
    'Discipline ID',
    'Group',
    'MRC Report Occupation',
    'O*NET-SOC Code',
    'Emergency Support Function',
    'Calculate Emergency Credential Level',
    'Occupation Credentials',
];
function mapCsvRowToData(row) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let i = -1;
        const id = ((_a = row.data[++i]) !== null && _a !== void 0 ? _a : '').trim();
        const name = ((_b = row.data[++i]) !== null && _b !== void 0 ? _b : '').trim();
        const status = ((_c = row.data[++i]) !== null && _c !== void 0 ? _c : '').trim().toLowerCase();
        const description = ((_d = row.data[++i]) !== null && _d !== void 0 ? _d : '').trim();
        const disciplineId = ((_e = row.data[++i]) !== null && _e !== void 0 ? _e : '').trim();
        const groupName = ((_f = row.data[++i]) !== null && _f !== void 0 ? _f : '').trim();
        const reportName = ((_g = row.data[++i]) !== null && _g !== void 0 ? _g : '').trim();
        const oNetSocCode = ((_h = row.data[++i]) !== null && _h !== void 0 ? _h : '').trim();
        const functionName = ((_j = row.data[++i]) !== null && _j !== void 0 ? _j : '').trim();
        const calculateEcl = ((_k = row.data[++i]) !== null && _k !== void 0 ? _k : '').trim().toLowerCase() === 'yes';
        const credentialsString = ((_l = row.data[++i]) !== null && _l !== void 0 ? _l : '').trim();
        if (name.length === 0) {
            row.errors.push('Name is required');
        }
        if (status.length === 0) {
            row.errors.push('Status is required');
        }
        switch (status) {
            case 'active':
            case 'deprecated':
            case 'retired':
                break;
            default:
                row.errors.push('Invalid status, expected one of: active, deprecated, retired');
        }
        const groupId = yield getClassifierIdByNameAsync('occupationGroup', groupName, row.errors, 'Group not found: ' + groupName);
        const reportId = yield getClassifierIdByNameAsync('occupationReport', reportName, row.errors, 'MRC Report Occupation not found: ' + reportName);
        const functionId = yield getClassifierIdByNameAsync('occupationFunction', functionName, row.errors, 'Emergency Support Function not found: ' + functionName);
        let credentials;
        if (credentialsString) {
            credentials = [];
            for (const partsString of credentialsString.split(';')) {
                const parts = partsString.split(':');
                const credentialName = parts[0];
                const jasBoardName = parts[1];
                const credentialId = yield getClassifierIdByNameAsync('occupationCredential', credentialName, row.errors, 'Occupation Credentials not found: ' + credentialName);
                const jasBoardId = yield getClassifierIdByNameAsync('jasBoard', jasBoardName, row.errors, 'Jas Board not found: ' + jasBoardName);
                const eclParts = parts.slice(1).map((s) => s.toLowerCase());
                if (credentialId) {
                    credentials.push({
                        credentialId: credentialId,
                        jasBoardId: jasBoardId,
                        ecl1: eclParts.includes('ecl 1'),
                        ecl2: eclParts.includes('ecl 2'),
                        ecl3: eclParts.includes('ecl 3'),
                        ecl4: eclParts.includes('ecl 4'),
                    });
                }
            }
        }
        if (row.errors.length === 0) {
            row.object = {
                id: id,
                data: {
                    name: name,
                    status: status,
                    description: description,
                    disciplineId: disciplineId,
                    groupId: groupId,
                    reportId: reportId,
                    oNetSocCode: oNetSocCode,
                    functionId: functionId,
                    calculateEcl: calculateEcl,
                    credentials: credentials,
                },
            };
        }
        return row;
    });
}
function mapDataToCsvRow(response) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const credentials = [];
        if (response.data.credentials) {
            for (const credential of response.data.credentials) {
                const parts = [];
                parts.push(yield getClassifierNameAsync('occupationCredential', credential.credentialId));
                parts.push(yield getClassifierNameAsync('jasBoard', credential.jasBoardId));
                if (credential.ecl1) {
                    parts.push('ECL 1');
                }
                if (credential.ecl2) {
                    parts.push('ECL 2');
                }
                if (credential.ecl3) {
                    parts.push('ECL 3');
                }
                if (credential.ecl4) {
                    parts.push('ECL 4');
                }
                credentials.push(parts.join(':'));
            }
        }
        return [
            response.id,
            response.data.name,
            response.data.status,
            (_a = response.data.description) !== null && _a !== void 0 ? _a : '',
            (_b = response.data.disciplineId) !== null && _b !== void 0 ? _b : '',
            yield getClassifierNameAsync('occupationGroup', response.data.groupId),
            yield getClassifierNameAsync('occupationReport', response.data.reportId),
            (_c = response.data.oNetSocCode) !== null && _c !== void 0 ? _c : '',
            yield getClassifierNameAsync('occupationFunction', response.data.functionId),
            response.data.calculateEcl ? 'yes' : 'no',
            credentials.join(';'),
        ];
    });
}
export const OccupationAdminPage = () => {
    const { credential: credentialEnabled } = useFeatureFlags();
    const buildFilter = (builder) => {
        builder.quickFilterMultiSelect({
            label: 'Group',
            widget: 'form.multiSelect',
            dataPath: 'groupId',
            valueProvider: {
                type: 'classifier.occupationGroup',
            },
        });
    };
    const mapFilter = (filterData) => {
        const filter = [];
        if (filterData === null || filterData === void 0 ? void 0 : filterData.groupId) {
            filter.push({
                column: 'groupId',
                op: 'in',
                value: filterData.groupId,
            });
        }
        return filter;
    };
    return (React.createElement(ClassifierAdminPage, { entity: occupationEntityName, title: 'Occupation', buildFilter: buildFilter, mapFilter: mapFilter, fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: (props) => React.createElement(EntityDetailsComponent, Object.assign({}, props, { credentialEnabled: credentialEnabled })), entityDetailsSlideoutWidth: 600, formConfig: formConfig(credentialEnabled), formWidth: 1000, csvFileHeader: csvFileHeader, mapCsvRowToData: mapCsvRowToData, mapDataToCsvRow: mapDataToCsvRow }));
};
